import React from 'react';
import type { FC } from 'react';
import { Link, SelectInput, Text } from '@wix/cli-ui-kit';
import type { VariantOf } from 'variant';
import { variant } from 'variant';

const VibeSetupChoice = variant({
  SetupVibe: {},
  Skip: {},
});

export type VibeSetupChoiceType = VariantOf<typeof VibeSetupChoice>;

export const ChooseVibeSetup: FC<{
  onSubmit: (choice: VibeSetupChoiceType) => void;
}> = ({ onSubmit }) => {
  return (
    <SelectInput<VibeSetupChoiceType>
      label="Would you like to set up your project for editing in Wix Vibe?"
      info={
        <>
          Use vibe coding with a drag-and-drop Editor and an IDE. Requires using
          GitHub to sync your project.{' '}
          <Link url="https://support.wix.com/en/using-wix-vibe">
            <Text underline>Learn more</Text>
          </Link>
        </>
      }
      options={[
        {
          key: 'setup-vibe',
          title:
            'Set up project for Wix Vibe and create a GitHub repository (recommended)',
          description:
            'Connects to GitHub, creates a repository, and syncs your code',
          value: VibeSetupChoice.SetupVibe(),
        },
        {
          key: 'skip',
          title: 'Skip for now',
          description: "Don't create a repo now, you can set this up later.",
          value: VibeSetupChoice.Skip(),
        },
      ]}
      onSubmit={({ value }) => onSubmit(value)}
    />
  );
};
